import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { getRoleHomePath } from "utils/paths";
import { LoadingScreen } from "./shared/LoadingScreen";

interface AdminRouteProps {
  redirectPath?: string;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ redirectPath }) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <LoadingScreen fullPage message="Checking permissions..." />;
  }

  if (!isAuthenticated || user?.role !== "ADMIN") {
    return (
      <Navigate to={redirectPath ?? getRoleHomePath(user?.role)} replace />
    );
  }

  return <Outlet />;
};

export default AdminRoute;
